/**
 * Design system & component showcase routes.
 * Only when running locally (`npm run serve`). Production builds omit routes, nav, and lazy chunks.
 */
export default process.env.NODE_ENV === 'development';
